import { IconButton } from "@mui/material"
import { FlexGrowComponent } from "fwork.react.apptemplate"
import React from "react"
import { FaTrash } from "react-icons/fa"
import { IoIosAdd, IoIosCheckmark, IoIosClose, IoIosRefresh } from "react-icons/io"
import Tooltip from '@mui/material/Tooltip';

export interface IHeaderComponentActions {
  icon: React.ReactNode,
  action: () => void,
  toolTip?: String,
  show?: Boolean
}

export const HeaderComponent = (props: {
  title: string | React.ReactNode,
  rightContent?: React.ReactNode,
  props?: React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>,
  onAddClick?: () => void,
  onRefreshClick?: () => void,
  onConfirmClick?: () => void,
  onRemoveClick?: () => void,
  onCancelClick?: () => void,
  customActions?: IHeaderComponentActions[],
  toolTipAdd?: String,
  toolTipRefresh?: String,
  toolTipConfirm?: String,
  toolTipRemove?: String,
  toolTipCancel?: String

}) => {
  return <div id='HeaderComponent' {...props.props} style={{
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
    ...props.props?.style
  }} >
    {typeof props.title == 'string' ? <h3>{props.title}</h3> : props.title}
    <FlexGrowComponent />

    {props.rightContent}

    <div>
      {props.customActions?.map((i, idx) =>
        i.show ? <Tooltip key={idx} title={i.toolTip}>
          <IconButton onClick={i.action} style={{ height: 46, width: 46 }}>
            {i.icon}
          </IconButton>
        </Tooltip> : <React.Fragment key={idx}></React.Fragment>
      )}

      {props.onRefreshClick ?
        <Tooltip title={props.toolTipRefresh}>
          <IconButton onClick={props.onRefreshClick} style={{ height: 46, width: 46 }}>
            <IoIosRefresh size={25} />
          </IconButton>
        </Tooltip> : <></>}

      {props.onAddClick ?
        <Tooltip title={props.toolTipAdd}>
          <IconButton onClick={props.onAddClick}>
            <IoIosAdd size={30} />
          </IconButton>
        </Tooltip>
        : <></>}

      {props.onConfirmClick ? <IconButton onClick={props.onConfirmClick}>
        <IoIosCheckmark size={30} />
      </IconButton> : <></>}

      {props.onRemoveClick ? <IconButton onClick={props.onRemoveClick} style={{ height: 46, width: 46 }}>
        <FaTrash size={15} />
      </IconButton> : <></>}

      {props.onCancelClick ? <IconButton onClick={props.onCancelClick}>
        <IoIosClose size={30} />
      </IconButton> : <></>}
    </div>
  </div>
}